package com.fireavert.react.pages.my_fire_risk

import com.fireavert.fire_risk.data_models.RiskLevel
import emotion.css.ClassName
import emotion.css.cx
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import web.cssom.Color

external interface FireRiskLabelProps : Props {
    var riskLevel: RiskLevel
}

val FireRiskLabelComponent = FC<FireRiskLabelProps> { props ->
    div {
        ariaLabel = "FireRiskLabelComponent"
        className =
            cx(FireRiskStyles.riskLabelParentStyle, ClassName { backgroundColor = Color(props.riskLevel.color) })
        div {
            className = FireRiskStyles.riskLabelNumber
            if (props.riskLevel.number > 0) {
                +(props.riskLevel.number.toString())
            }
        }
        div {
            className = FireRiskStyles.riskLabelDivider
        }
        div {
            className = FireRiskStyles.riskLabelDescription
            +(props.riskLevel.description)
        }
    }
}